import api from "api";
import secureLocalStorage from "react-secure-storage";

export function engagementReport(sd,ed) {
  return api.get(`revenueReport/${secureLocalStorage.getItem('id')}?isSupervisor=${secureLocalStorage.getItem('is_supervisor')}&start=${sd}&end=${ed}`)
}
